import request from '@/utils/request'

export function getRoleList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/Role/Role/List',
        method: 'post',
        data
    })
}

export function rolePeopleAddRole(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/Role/People/AddRole',
        method: 'post',
        data
    })
}


export function lock(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/lock',
        method: 'post',
        data
    })
}

export function resetPassword(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/resetpassword',
        method: 'post',
        contentType: 'json',
        data: '"' + data.ID + '"'
    })
}

export function getUserEditDetail(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/editdetail',
        method: 'get',
        params: data
    })
}

export function getUserDetail(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/detail',
        method: 'get',
        params: data
    })
}

export function getUserList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/pagelist',
        method: 'get',
        params: data
    })
}

export function addUser(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/adduser',
        method: 'post',
        data
    })
}

export function editUser(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/edituser',
        method: 'post',
        data
    })
}

export function deleteUser(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/deleteuser',
        method: 'post',
        contentType: 'json',
        data: '"' + data.ID + '"'
    })
}

export function getOrganizationList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/organization/list',
        method: 'get',
        params: data
    })
}

export function getWebSiteList(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/website/list',
        method: 'get',
        params: data
    })
}

export function getAllLoginLog(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/allloginlog',
        method: 'get',
        params: data
    })
}

export function getMyLoginLog(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/loginlog',
        method: 'get',
        params: data
    })
}

export function forceQuiteUser(data) {
    return request({
        baseURL: process.env.VUE_APP_System_Api,
        url: '/api/user/forcequite',
        method: 'post',
        contentType: 'json',
        data: '"' + data.ConnectionID + '"'
    })
}


// WEBPACK FOOTER //
// ./src/areas/systemmanage/api/user.js